import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Per-asset trail visibility. The map's View-options Trail button is the
 * GLOBAL switch (all assets); this store hides individual assets' trails —
 * toggled from the asset row in the FleetSidebar. Hidden set persists.
 */
interface TrailPrefsStore {
  hidden: Record<string, true>;
  /** Per-asset trail colour (hex). Missing = the accent default. */
  colors: Record<string, string>;
  toggle: (robotId: string) => void;
  setColor: (robotId: string, color: string | null) => void;
  isHidden: (robotId: string) => boolean;
}

export const useTrailPrefs = create<TrailPrefsStore>()(
  persist(
    (set, get) => ({
      hidden: {},
      colors: {},
      toggle: (robotId) =>
        set((s) => {
          const next = { ...s.hidden };
          if (next[robotId]) delete next[robotId];
          else next[robotId] = true;
          return { hidden: next };
        }),
      setColor: (robotId, color) =>
        set((s) => {
          const next = { ...s.colors };
          if (color) next[robotId] = color;
          else delete next[robotId];
          return { colors: next };
        }),
      isHidden: (robotId) => get().hidden[robotId] === true,
    }),
    { name: 'fabricos.trailPrefs.v1' },
  ),
);
